import React, { FC, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { AddEmployeesToAppointmentOptions } from '../../../../../../../../interfaces/api/Collaborative';
import { Controller, useForm } from 'react-hook-form';
import LegacyEmployeeSelect from '../../../../../../../../components/ApiField/LegacyEmployeeSelect';
import { createUseStyles } from '../../../../../../../../theming';

const apiEmployeeShow = '/api/employee/';
const apiAppointmentType = '/api/appointment/getAppointmentTypes/';

const useStyles = createUseStyles({
  title: {
    width: 400,
    '& h2': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  formControl: {
    marginBottom: '16px !important',
  },
});

interface Props {
  open: boolean;
  onClose: () => void;
  onValidate: (addEmployeesToAppointmentOptions: AddEmployeesToAppointmentOptions) => void;
}

const AddEmployeeDialog: FC<Props> = ({ open, onClose, onValidate }) => {
  const classes = useStyles();

  const [formError, setFormError] = useState<string | undefined>();
  const {
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<AddEmployeesToAppointmentOptions>({
    defaultValues: {
      employeeSelectedId: [],
    },
  });

  useEffect(() => {
    setFormError(undefined);
  }, []);

  const onSubmit = async (addEmployeesToAppointmentOptions: AddEmployeesToAppointmentOptions) => {
    try {
      setFormError(undefined);
      await onValidate(addEmployeesToAppointmentOptions);
      onClose();
    } catch (e) {
      setFormError(e.message);
    }
  };

  return (
    <Dialog onClose={onClose} scroll='paper' open={open}>
      <DialogTitle className={classes.title}>Rendez-vous</DialogTitle>

      <DialogContent>
        <DialogContentText>Ajouter des employés au rendez-vous.</DialogContentText>

        <Controller
          name='employeeSelectedId'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <LegacyEmployeeSelect
              {...field}
              multiple
              className={classes.formControl}
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' color='primary' onClick={handleSubmit(onSubmit)}>
          Ajouter
        </Button>
      </DialogActions>

      {formError && <p className={classes.error}>{formError}</p>}
    </Dialog>
  );
};

export default AddEmployeeDialog;
